export const SEARCH_ITEMS_ADD = 'SEARCH_ITEMS_ADD';
export const SEARCH_ITEMS_RESET = 'SEARCH_ITEMS_RESET';